import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { enableProdMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { provideRouter, Routes } from '@angular/router';
import { routes } from './app.routes';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptorConfiguration,
  MsalService,
  MsalBroadcastService,
  MsalGuard,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { AuthenticationInterceptor } from './share/interceptor/authentication.interceptor';
import { AuthService } from './share/services/auth.service';

import { provideToastr } from 'ngx-toastr';

import { LayoutService } from './components/layout/layout.service';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { ConfigService } from './share/services/config.service';

import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from './app.environment.config';

// TODO // const options = {
//   preserveWhitespaces: false
// };

// if (environment.production) {
//   enableProdMode();
// } else {
//   options.preserveWhitespaces = true;
// }

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(config: ConfigService): IPublicClientApplication {
  console.log('NEW MSAL INSTANCE');
  return new PublicClientApplication({
    auth: {
      clientId: config.getEnv('fetrapiClientID') as string,
      authority: config.getEnv('fetrapiAuthority') as string,
      redirectUri: config.getEnv('fetrapiLoginRedirectURL') as string,
      postLogoutRedirectUri: config.getEnv('fetrapiLoginPostLogoutRedirectUri') as string
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(config: ConfigService): MsalInterceptorConfiguration {
  console.log('NEW MSAL INTERCEPTOR');
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    config.getEnv('apiConfigUri') as string,
    [...config.getEnv('apiConfigScopes') as string[]]
  );
  protectedResourceMap.set(
    'https://merkator-fetrapi-web-api.azurewebsites.net',
    []
  )

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(config: ConfigService): MsalGuardConfiguration {
  console.log('NEW MSAL GUARD');
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: config.getEnv('apiConfigScopes') as string[]
    },
    loginFailedRoute: '/login-failed',
  };
}

export const createAppConfig = (config: EnvironmentConfiguration): ApplicationConfig => {
  return {
    providers: [
      { provide: ENVIRONMENT_CONFIG, useValue: config },
      ConfigService,
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes),
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi(), withFetch()),
      provideToastr({}),
      importProvidersFrom(AngularSlickgridModule.forRoot()),
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthenticationInterceptor,
        multi: true,
      },
      {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory,
        deps: [ConfigService]
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory,
        deps: [ConfigService]
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory,
        deps: [ConfigService]
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      AuthService,
      LayoutService,
      ],
  };
};


// export const appConfig: ApplicationConfig = {
//   providers: [
//     ConfigService,
//     // provideAppInitializer(() => {
//     //   const config = inject(ConfigService);
//     //   return config.load();
//     // }),
//     provideZoneChangeDetection({ eventCoalescing: true }),
//     provideRouter(routes),
//     provideAnimations(),
//     provideHttpClient(withInterceptorsFromDi(), withFetch()),
//     provideToastr({}),
//     importProvidersFrom(AngularSlickgridModule.forRoot()),
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: AuthenticationInterceptor,
//       multi: true,
//     },
//     {
//       provide: MSAL_INSTANCE,
//       useFactory: MSALInstanceFactory,
//       deps: [ConfigService]
//     },
//     {
//       provide: MSAL_GUARD_CONFIG,
//       useFactory: MSALGuardConfigFactory,
//       deps: [ConfigService]
//     },
//     {
//       provide: MSAL_INTERCEPTOR_CONFIG,
//       useFactory: MSALInterceptorConfigFactory,
//       deps: [ConfigService]
//     },
//     MsalService,
//     MsalGuard,
//     MsalBroadcastService,
//     AuthService,
//     LayoutService,
//   ],
// };
